import { NgModule } from 'ng-metadata/core';
import {PreFiltersService} from './preFilters.service';
import {PrmPreFilters} from './preFilters.directive';

@NgModule({
    declarations: [
       PrmPreFilters
    ],
    providers: [
        PreFiltersService
    ],
    imports:[]
})
export class PreFiltersModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/preFilters/preFilters.module.ts